import { render, staticRenderFns } from "./login-alternate.vue?vue&type=template&id=2b2a9801&scoped=true"
import script from "./login-alternate.vue?vue&type=script&lang=js"
export * from "./login-alternate.vue?vue&type=script&lang=js"
import style0 from "./login-alternate.vue?vue&type=style&index=0&id=2b2a9801&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b2a9801",
  null
  
)

export default component.exports